// Hero — Swiper carousel controller.
// Only initialises Swiper when the wrapper carries data-hero-slider="true",
// which the Blade template adds only in the canvas editor or when 2+ slides
// have been saved. A single-slide live hero renders without that attribute
// and without any Swiper DOM, so no JS is executed and there are no errors.

common.View.create('canvas.blocks.site.hero.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        const $slider = this.element.find('.site-hero-slider[data-hero-slider="true"]');
        if (!$slider.length || typeof Swiper === 'undefined') return;

        const el = $slider[0];

        // Defensive: drop any prior Swiper bound to this element before
        // re-binding (handles editor save re-render race conditions).
        if (el.swiper && typeof el.swiper.destroy === 'function') {
            el.swiper.destroy(true, true);
        }

        const isEditor = $('body').hasClass('canvas-editor');

        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 0,
            // No loop: the nav arrows need a real first/last slide to show
            // their disabled state. Autoplay rewinds to slide 1 at the end.
            loop: false,
            // Autoplay on the live site only — in the editor the slides must
            // stay put while you're working on them.
            autoplay: isEditor
                ? false
                : { delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true },
            // watchOverflow auto-disables nav, pagination, and touch on
            // single-slide instances in the editor — so if the editor has
            // only 1 slide the scaffold is silent.
            watchOverflow: true,
            allowTouchMove: !isEditor,
            grabCursor: !isEditor,
            navigation: {
                prevEl: this.element.find('.site-hero-nav--prev')[0],
                nextEl: this.element.find('.site-hero-nav--next')[0],
            },
            pagination: {
                el: this.element.find('.site-hero-pagination')[0],
                clickable: !isEditor,
            },
            a11y: {
                prevSlideMessage: 'Vorige slide',
                nextSlideMessage: 'Volgende slide',
            },
            keyboard: { enabled: !isEditor },
        });
    },
});
